var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_740_8291",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_740_8291)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.7665 18.7228C6.4645 18.8434 6.17792 18.8178 5.90675 18.6458C5.63558 18.4738 5.5 18.2233 5.5 17.8943V13.673L12.423 12L5.5 10.327V6.10576C5.5 5.77676 5.63558 5.52626 5.90675 5.35426C6.17792 5.18226 6.4645 5.1566 6.7665 5.27726L20.723 11.1615C21.0948 11.328 21.2807 11.6081 21.2807 12.0018C21.2807 12.3954 21.0948 12.6743 20.723 12.8385L6.7665 18.7228Z",
    fill: "#141414"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendFill);
export default __webpack_public_path__ + "static/media/send_fill.7d309325ccdb5f41d51172dfbd310f22.svg";
export { ForwardRef as ReactComponent };